import { useHeaderLoginState } from "@app/app/models/AppStore";
import OpenApiClient from "@app/shared/api/OpenApiClient.ts";
import { LoadingIndicator } from "@app/shared/ui/LoadingIndicator";
import { Group, Stack, Text } from "@mantine/core";
import { setAuthToken } from "@shared/api/Auth.ts";
import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

export const LoginFromFxEmail = () => {
	const { t } = useTranslation();

	const [, { disable: disableHeaderLogin, enable: enableHeaderLogin }] = useHeaderLoginState();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const isLoginInitiated = useRef(false);
	const [redirectingTo, setRedirectingTo] = useState<string | null>();
	const { mutate: login } = useMutation({
		mutationFn: async () => {
			if (isLoginInitiated.current) return;
			isLoginInitiated.current = true;
			const InviteToken = searchParams.get("inviteToken");
			if (!InviteToken) throw new Error("[AUTH] No token in querystring");
			const result = await OpenApiClient.Auth.fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpoint({
				InviteToken
			});
			if (!result.Success || !result.Token) throw new Error(String(result.Error));
			return result;
		},
		onError: (error) => navigate("/error", { state: { status: 0, body: JSON.stringify(error) } }),
		onSuccess: (result) => {
			if (result?.Token != null) setAuthToken(result.Token);

			if (result?.RedirectUri != null) {
				setRedirectingTo(result.RedirectUri);
				window.location.href = result.RedirectUri;
				// navigate(result.RedirectUri);
			} else {
				navigate("/");
			}
		}
	});
	useEffect(() => {
		disableHeaderLogin();
		return () => enableHeaderLogin();
	}, [disableHeaderLogin, enableHeaderLogin]);

	useEffect(() => {
		if (isLoginInitiated.current) return;
		login();
	}, [login]);

	return (
		<Stack gap="md" justify="flex-start" align="center">
			<Group justify="center">
				{!redirectingTo && <Text>{t("loading")}</Text>}
				{redirectingTo && (
					<Text>
						{t("redirecting")}
						<br />
						<a href={redirectingTo}>Click here for manual redirect ...</a>
					</Text>
				)}
				<LoadingIndicator />
			</Group>
		</Stack>
	);
};
